export const POST_LIVESTREAM = "POST_LIVESTREAM";
export const FETCH_ALL_LIVESTREAMS = "FETCH_ALL_LIVESTREAMS";